import { useEffect } from 'react';

import type {
	RovoConfiguration,
	RovoConfigurationProviderProps,
} from '@confluence/rovo-config-provider-common/entry-points/rovoConfigTypes.ts';

const EMPTY_ROVO_CONFIG: RovoConfiguration = {
	getActions: async () => [],
};

export const HomeRovoConfigProvider = ({
	setConfiguration,
}: RovoConfigurationProviderProps): null => {
	useEffect(() => {
		setConfiguration(EMPTY_ROVO_CONFIG);
	}, [setConfiguration]);

	return null;
};
